import calculateSavingsTotalByTranType from "../savings/objects/calculate_savings_total_by_tran_type";

export const addSavingsTaxTransactions = (summaryTranArr, savingsClass) => {
    let taxDetailArr = [];
    let taxSummaryTranArr = [];
    for (let i=0; i<summaryTranArr.length; i++){
        if (summaryTranArr[i].savingsClass === savingsClass){
            const taxArr = summaryTranArr[i].taxHistoryArr;
            let reformatTaxArr = [];
            for (let j=0; j<taxArr.length; j++){
                const newTaxObj = {tranType: taxArr[j].taxLongText,
                    tranAmt: taxArr[j].tranAmount,
                    tranDate: taxArr[j].tranDate,
                    taxRate: taxArr[j].taxRate,
                    taxIncomeAmt: taxArr[j].incomeAmt,
                    tranNbr: 9999, 
                    className: "font-weight-bold"
                }
                reformatTaxArr.push(newTaxObj);
            }
            if (reformatTaxArr.length > 0){
                const taxObj = {
                    savingsClass: summaryTranArr[i].savingsClass,
                    savingsType:  summaryTranArr[i].savingsType,
                    savingTranArr: reformatTaxArr
                    }
                    taxDetailArr.push(taxObj);
                taxSummaryTranArr.push(summaryTranArr[i]);
            }
        }
    }
    let taxArr = [];
    if (taxDetailArr.length > 0){
        taxArr = calculateSavingsTotalByTranType(taxSummaryTranArr, savingsClass, 9999, taxDetailArr);
    }
    return taxArr;
}
export default addSavingsTaxTransactions;